export const AuditColorMapInfo: any = {
  "completed": "#DFF7DF",
  "pending": "#FFF5D6",
  "failed": "#FFD6D6",
  "in-progress": "#D6E4FF",
  "scheduled": "#9AF0E1"
}